module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/045-andorra-3548b1878776d88388783f719a8428ac.svg";